import React from 'react';
import ReactLoading from 'react-loading';
import './Loading.css';

const Loading = ({ condition, children }) =>
  condition ? (
    <div className="u-fx u-fx-align-center u-fx-justify-center">
      <ReactLoading type="balls" color="#34495e" />
    </div>
  ) : (
    <div>{children}</div>
  );

export default Loading;
